module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('overlay', {
    attrs: {
      "isFullScreen": true
    }
  }), _vm._v(" "), _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-content', {
    attrs: {
      "id": "mainContent"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    staticClass: "white--text",
    attrs: {
      "color": "blue-grey"
    }
  }, [_c('v-toolbar-title', [_vm._v("Team Portal Login")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "prepend-icon": "person",
      "error": _vm.errors.first('login'),
      "name": "login",
      "label": "Login",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.errors.first('login')))]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "prepend-icon": "lock",
      "error": _vm.errors.first('password'),
      "name": "password",
      "label": "Password",
      "id": "password",
      "type": "password"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]), _vm._v(" "), (_vm.validationRequired) ? _c('v-text-field', {
    attrs: {
      "prepend-icon": "laptop",
      "name": "Validation Code",
      "label": "Validation Code",
      "id": "validationCode",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.validationCode),
      callback: function($$v) {
        _vm.validationCode = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "validationCode"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "text-xs-left mx-5"
  }, [_vm._v("\n                                    Access to this information resource is restricted to authorized users only. This information resource may be monitored for administrative and security reasons. By proceeding, you consent to this monitoring. In order to protect the information entrusted to Sedgwick, unauthorized access and/or unauthorized use of this information resource may be prosecuted to the fullest extent of the law.\n                                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f2357764", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2357764"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/login/login.vue.html
// module id = 595
// module chunks = 0